/*
 * Moonji product gallery carousel.
 * Progressive enhancement over a scroll-snap track: swiping/scrolling already
 * works with zero JS, this file just adds arrow buttons and keeps the dots in sync.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-pdp-gallery-track]');
    var slides = gallery.querySelectorAll('[data-pdp-gallery-slide]');
    var prevBtn = gallery.querySelector('[data-pdp-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-pdp-gallery-next]');
    var dots = gallery.querySelectorAll('[data-pdp-gallery-dot]');
    if (!track || slides.length < 2) return;

    var current = 0;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      // Scroll the track itself, not scrollIntoView: it's the one axis that
      // needs to move, and offsetLeft is reliable regardless of RTL/browser quirks.
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function setActive(index) {
      current = index;
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });

    // Keeps the dots (and "current") correct on swipe/scroll too, not just button clicks.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = Array.prototype.indexOf.call(slides, entry.target);
            if (index > -1) setActive(index);
          }
        });
      }, { root: track, threshold: 0.6 });

      slides.forEach(function (slide) { observer.observe(slide); });
    }
  });
})();
